import TextField, { TextFieldProps } from '@mui/material/TextField';
import * as React from 'react';

type Props = Omit<
    TextFieldProps,
    'name' | 'value' | 'select' | 'SelectProps' | 'onChange' | 'onBlur'
> & {
    /* TIP: fieldName property will be used as the object key in the onChangeHandler reducer */
    fieldName: string;
    fieldValue: any;
    onChangeHandler: React.Dispatch<{ [key in string]: string }>;
    select?: boolean;
    isError?: boolean;
};

/**
 * TextFieldFast
 *
 * @description
 * A wrapper for Mui-TextField component which prevents updates to the parent component's state
 * until the user has focused away from the input.
 *
 * @hidden
 * Useful in large forms where updates to a parent component on each keypress could cause poor
 * user experience due to slow feedback
 */
export default function TextFieldFast({
    fieldName,
    fieldValue,
    onChangeHandler,
    select,
    isError,
    ...props
}: Props) {
    const [text, setText] = React.useState<string>(fieldValue);

    React.useEffect(() => {
        if (fieldValue !== text) {
            setText(fieldValue);
        }
    }, [fieldValue]);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setText(event.target.value);
    };

    const handleBlur = () => {
        onChangeHandler({ [fieldName]: text });
    };

    return (
        <TextField
            {...(props as TextFieldProps)}
            error={isError}
            name={fieldName}
            value={text}
            select={select}
            onChange={handleChange}
            onBlur={handleBlur}
        />
    );
}
